import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ToolTip from '../../components/Tooltip/Tooltip';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import FunnelChart from './components/FunnelChart';
import classes from './Funnel.module.css';

const Funnel = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, day].join('-');
		return dateFormat.toString();
	}

	const firstDateFilter = new Date();
	const date1 = formatDate(firstDateFilter.setMonth(firstDateFilter.getMonth() - 12));

	const secondDateFilter = new Date();
	const date2 = formatDate(secondDateFilter.setMonth(secondDateFilter.getMonth() - 1));

	//Filters
	const [country, setCountry] = useState('Todos');
	//const [moneda, setMoneda] = useState('CLP');
	const [clasificacion, setClasificacion] = useState(0);
	const [initialDate, setInitialDate] = useState(date1);
	const [endDate, setEndDate] = useState(date2);

	//Apis
	const [funnelUrl, setFunnelUrl] = useState(`/funnelEmpresas?dateFrom=${initialDate}&dateTo=${endDate}`);

	//Data
	const [funnel, setDataFunnel] = useState([]);

	//Aux
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	//Evaluar si conviene cada carga segun un useEffect

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			Axios.all([Axios.get(funnelUrl)]).then(
				Axios.spread((obj1) => {
					try {
						setDataFunnel(obj1.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData();
	}, [funnelUrl]);

	return (
		<Fragment>
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								setFunnelUrl(
									`/funnelEmpresas?dateFrom=${initialDate}&dateTo=${endDate}&pais=${country}&clasificacion=${clasificacion}`,
								);

								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={country} onChange={(event) => setCountry(event.target.value)}>
										<option value={'Todos'}>Todos los Países</option>
										<option value={'Chile'}>Chile</option>
										<option value={'Peru'}>Peru</option>
										<option value={'Argentina'}>Argentina</option>
										<option value={'Mexico'}>Mexico</option>
									</select>
								</div>

								<div>
									<select value={clasificacion} onChange={(event) => setClasificacion(event.target.value)}>
										<option value={'0'}>Pyme y Corp</option>
										<option value={'1'}>Pyme</option>
										<option value={'2'}>Corp</option>
									</select>
								</div>

								<div>
									<input type="date" id="dateDesde" value={initialDate} onChange={(event) => setInitialDate(event.target.value)} />
								</div>

								<div>
									<input type="date" id="dateHasta" defaultValue={endDate} onChange={(event) => setEndDate(event.target.value)} />
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>
			<Grid item xs={12}>
				<Grid container spacing={3}></Grid>
			</Grid>
			{/* Sección 2 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<ToolTip
								text={
									'Este gráfico muestra el movimiento de los ingresos entre las fechas seleccionadas, siempre y cuando existan registros'
								}
							/>
							<div className={classes.barChartVentas}>
								<FunnelChart data={funnel} isLoading={isLoading} />
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
	// return React.createElement('div', {className: 'App'}, React.createElement('h1', null, 'Does this work now?'));
};

export default React.memo(Funnel, Axios);
